import { useCallback, useState } from "react";

import { ADJACENT_OFFSET, EMPTY_LENGTH, INITIAL_INDEX } from "../constants/numeric";
import { LensHistoryItem } from "../utils/lensHistoryStorage";
import { LENS_NAVIGATION_DIRECTION, LensNavigationDirection } from "../utils/lensNavigation";

interface UseHistoryModalReturn {
  open: boolean;
  setOpen: (open: boolean) => void;
  currentItem: LensHistoryItem | null;
  modalIndex: number;
  handleOpen: () => void;
  handleNavigate: (direction: LensNavigationDirection) => void;
}

export const useHistoryModal = (allHistory: LensHistoryItem[]): UseHistoryModalReturn => {
  const [open, setOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(INITIAL_INDEX);

  const handleOpen = useCallback((): void => {
    const lastIndex = allHistory.length > EMPTY_LENGTH
      ? allHistory.length - ADJACENT_OFFSET
      : INITIAL_INDEX;
    setModalIndex(lastIndex);
    setOpen(true);
  }, [allHistory.length]);

  const handleNavigate = useCallback((direction: LensNavigationDirection): void => {
    const maxIndex = allHistory.length - ADJACENT_OFFSET;
    if (direction === LENS_NAVIGATION_DIRECTION.Previous && modalIndex > INITIAL_INDEX) {
      setModalIndex(modalIndex - ADJACENT_OFFSET);
      return;
    }
    if (direction === LENS_NAVIGATION_DIRECTION.Next && modalIndex < maxIndex) {
      setModalIndex(modalIndex + ADJACENT_OFFSET);
    }
  }, [modalIndex, allHistory.length]);

  const currentItem = allHistory[modalIndex] || null;

  return { open, setOpen, currentItem, modalIndex, handleOpen, handleNavigate };
};
